import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from '@/stores/action/home.action';
import { getLocaleWordContent } from '@/utils/language.util';

function Box({ user, UserActions }) {
    const fetchBusinesses = () => {
        UserActions.getUserBalance();
    };
    useEffect(fetchBusinesses, []);
    return (
        <>
            <div className="bg_balance_left">
                <div className="sp10"></div>
                <div className="inner">
                    <div className="content_box">
                        <div className="box_coin">
                            <p className="gray">ID</p>
                            <p className="gray">{getLocaleWordContent('이름')}</p>
                        </div>
                        <div className="box_coin">
                            <p className="black">{user.getIn(['id']) || ''}</p>
                            <p className="black">{user.getIn(['name']) || ''}</p>
                        </div>
                    </div>
                    <div className="sp25"></div>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        user: state.home.getIn(['user']),
    }),
    (dispatch) => ({
        UserActions: bindActionCreators(userActions, dispatch),
    }),
)(Box);
